import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import Hero from "./components/Hero";
import HotTicker from "./components/HotTicker";
import FeaturedTopics from "./components/FeaturedTopics";
import CategoryGrid from "./components/CategoryGrid";
import IntroSection from "./components/IntroSection";
import VoicesSection from "./components/VoicesSection";
import FaqSection from "./components/FaqSection";
import SubmitCta from "./components/SubmitCta";
import { faqs } from "@/mocks/faqs";
import { siteMeta } from "@/mocks/site";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteMeta.name,
    url: "https://gaohaoshuzi.cn/",
    description:
      "爆料91聚合吃瓜现场之外的网友讨论、评论区观点与舆论反应，热门讨论实时滚动更新。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://gaohaoshuzi.cn/topics?keyword={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteMeta.name,
    url: "https://gaohaoshuzi.cn/",
    email: siteMeta.email,
    description: siteMeta.intro,
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  },
];

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Seo
        title="爆料91 · 吃瓜现场外的热议讨论与评论区观点聚合"
        description="爆料91聚焦吃瓜现场之外的网友讨论，实时滚动热门话题、评论区观点与舆论反应，围观综艺、影视、音乐现场等热议事件，参与爆料91热议话题。"
        keywords="爆料91,爆料91热议话题,爆料91网友讨论,爆料91评论区,爆料91热门讨论,爆料91舆论反应"
        path="/"
        jsonLd={jsonLd}
      />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <HotTicker />
        <FeaturedTopics />
        <CategoryGrid />
        <IntroSection />
        <VoicesSection />
        <FaqSection />
        <SubmitCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}